import { fetchWithAuth } from "~/common/fetch";
import { rework3DPlanNotification } from "~/components/notifications/rework_3d_plan_notification";
import { API_REWORK_PLAN } from "~/config";
import type { TUserActionNotification } from "~/reducers/dashboard";
import type { AppDispatch } from "~/store";
import type { TPatient } from "~/types/patient";

import { addUserActionNotification } from "./user_notification";

export function tryToReworkPlan(patient_id: TPatient["patient_id"], case_id: string) {
  const NOTIFICATION_MSG_OK: TUserActionNotification = {
    message: "notify.rework.ok",
    level: "success",
    position: "tc",
    autoDismiss: 10,
    children: rework3DPlanNotification(),
  };

  const NOTIFICATION_MSG_ERROR: TUserActionNotification = {
    message: "notify.rework.error",
    level: "error",
    position: "tl",
    autoDismiss: 4,
  };

  return async (dispatch: AppDispatch) => {
    try {
      const response = await fetchWithAuth(API_REWORK_PLAN(patient_id), {
        method: "POST",
        body: JSON.stringify({ plan_id: parseInt(case_id) }),
      });
      if (!response.ok) {
        throw Error("Error occurred trying to proceed plan adjusting!");
      }
      const json = await response.json();

      dispatch({ type: "POST_PLAN_SEND_TO_REWORK", json: json.patient });
      dispatch(addUserActionNotification(NOTIFICATION_MSG_OK));
    } catch {
      dispatch(addUserActionNotification(NOTIFICATION_MSG_ERROR));
    }
  };
}
